import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NovedadesTiempos } from '../../../../models/novedadesTiempos';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { PersonalService } from '../../../../services/personal.service';
import { formatDate } from '@angular/common';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-tiempos-detalle',
  templateUrl: './novedades-tiempos-detalle.component.html',
  styleUrls: ['./novedades-tiempos-detalle.component.css']
})
export class NovedadesTiemposDetalleComponent implements OnInit {

  codigosNominaList: any;
  unidadesList: any;

  constructor(private configDataSrv: ConfigDataService,
              private codigosNominaService: CodigosNominaService,
              private fb: FormBuilder,
              private personalService: PersonalService,
              private momentService: MomentSetService) { }

  @Input() set novedadTiempo(novedadRecibida: NovedadesTiempos)
  {
    this.novedadTiempoForm = novedadRecibida;
    this.setearForm(novedadRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() novedadesInvalida: boolean;

  form: FormGroup;
  novedadTiempoForm: NovedadesTiempos;
  actualizarFormatoInputNumerico = false;
  NominaList: any
  submitted: boolean;
  tipoCarga: number;
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.tipoCarga = 0;
    
    this.configDataSrv.getDatosNominas()
      .subscribe(
        data => {
          this.unidadesList=data["UnidadesMedidas"];
        },
        error => {
          console.log(error);
        });
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.NominaList = codigos;
        this.cargaConceptos();
      });
    
    this.configurarValidadores();
    this.setearForm(this.novedadTiempoForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      fecha: ['', Validators.required],
      cantidad: [''],
      motivo: [''],
      unidadMedida: ['', Validators.required],
      codigosNomina: ['', Validators.required],
      importe: [''],
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(novedadTiempo: NovedadesTiempos)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(novedadTiempo?.id);
      this.form.controls['personal'].setValue(novedadTiempo?.personal);
      this.form.controls['fecha'].setValue(new Date(novedadTiempo?.fecha));
      this.form.controls['cantidad'].setValue(novedadTiempo?.cantidad);
      this.form.controls['motivo'].setValue(novedadTiempo?.motivo);
      this.form.controls['unidadMedida'].setValue(novedadTiempo?.unidadMedida);
      this.form.controls['codigosNomina'].setValue(novedadTiempo?.codigosNomina);
      this.form.controls['importe'].setValue(novedadTiempo?.importe);

      if (novedadTiempo.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.form.controls['unidadMedida'].disable();
      this.getTipoCargaCodigoNomina(this.novedadTiempoForm.codigosNomina);
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
      this.form.controls['importe'].setValue(this.novedadTiempoForm?.importe);
      this.actualizarFormatoInputNumerico = true;
    }
  }

  onChangeCodigoNomina(event)
  {
    this.getTipoCargaCodigoNomina(event.value);
    if (this.tipoCarga == 2) 
    {
      this.form.controls['importe'].setValue(0);
    } else if (this.tipoCarga == 1)
    {
      this.form.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['cantidad'].setValue(0);
    }
    let unidadMedida = this.codigosNominaList.find(c => c.id == event.value).um;
    this.form.controls['unidadMedida'].setValue(unidadMedida);
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  cargaConceptos()
  {
    //Carga los conceptos validos
    let fecha = this.form.get("fecha").value.toDateString();
    let concepto = this.form.get("codigosNomina").value;

    this.codigosNominaList = this.NominaList && this.NominaList.filter(items => items.novedadesTiempos == true &&
                                                                                Date.parse(items.desde) <= Date.parse(fecha) &&
                                                                                Date.parse(items.hasta) >= Date.parse(fecha)) ;
    
    let index = this.codigosNominaList.findIndex(x => x.id == concepto)
    if (index == -1)
    {
      //No existe en la nueva lista, lo limpio
      this.form.controls['codigosNomina'].setValue(null);
    }
  }

  onChangeFechas()
  {
    this.cargaConceptos();
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("fecha").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.novedadTiempoForm.personal, 'NovedadesTiempos', desde, desde, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }

}
